import { defaultSlickResponsive } from '@gn-audio/angularjs-components/slick/constants/default-slick-responsive';
import { IHasSlickSliderScope } from '@gn-audio/angularjs-components/slick/models/has-slick-slider-scope';
import { fetchFamilies } from '@gn-audio/core/api/product-catalogue/fetch-families';
import { fetchGroups } from '@gn-audio/core/api/product-catalogue/fetch-groups';
import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { IGroup } from '@gn-audio/core/api/product-catalogue/models/group';

interface IRelatedProductsConfigurationScope extends ng.IScope, IHasSlickSliderScope {
  groupIds: number[];
  groups: IGroup[];
  groupsLoaded: boolean;
  familyIds: number[];
  families: IFamily[];
  familiesLoaded: boolean;
  relatedProducts: (IFamily | IGroup)[];
}

/**
 * @deprecated Should be converted into component!
 */
export class RelatedProductsConfigurationController implements ng.IController {
  public static $inject: ReadonlyArray<string> = ['$scope', '$q'];

  constructor(private $scope: IRelatedProductsConfigurationScope, private $q: ng.IQService) {
    this.$scope.groupIds = [];
    this.$scope.groups = [];
    this.$scope.groupsLoaded = false;
    this.$scope.familyIds = [];
    this.$scope.families = [];
    this.$scope.familiesLoaded = false;

    const $groupIdsWatcher = this.$scope.$watch(
      'groupIdsJson',
      (oldValue: string, newValue: string): void => {
        this.$scope.groupIds = JSON.parse(newValue) as number[];
        if (!Array.isArray(this.$scope.groupIds) || this.$scope.groupIds.length === 0) {
          this.$scope.groupsLoaded = true;
          return;
        }

        $groupIdsWatcher();
        this.$q
          .when(fetchGroups(this.$scope.groupIds))
          .then((groups: IGroup[]): void => {
            this.$scope.groups = groups;
            this.$scope.groupsLoaded = true;
            if (this.$scope.familiesLoaded) {
              this.$scope.relatedProducts = (this.$scope.relatedProducts || [])
                .concat(this.$scope.groups)
                .concat(this.$scope.families);
            }
          });
      },
    );

    const $familyIdsWatcher = this.$scope.$watch(
      'familyIdsJson',
      (oldValue: string, newValue: string): void => {
        this.$scope.familyIds = JSON.parse(newValue) as number[];
        if (!Array.isArray(this.$scope.familyIds) || this.$scope.familyIds.length === 0) {
          this.$scope.familiesLoaded = true;
          return;
        }

        $familyIdsWatcher();
        this.$q
          .when(fetchFamilies(this.$scope.familyIds))
          .then((families: IFamily[]): void => {
            this.$scope.families = families;
            this.$scope.familiesLoaded = true;
            if (this.$scope.groupsLoaded) {
              this.$scope.relatedProducts = (this.$scope.relatedProducts || [])
                .concat(this.$scope.groups)
                .concat(this.$scope.families);
            }
          });
      },
    );
  }

  public $onInit() {
    this.$scope.responsive = defaultSlickResponsive;
  }
}
